import Button from "components/BaseWidgets/button";
import "./style.scss";
import chromeIcon from "assets/images/svg/chrome-icon.svg";
import safariIcon from "assets/images/svg/safari-icon.svg";
import Divider from "components/BaseWidgets/divider";
import ActionModal from "components/Settings/components/ActionModal";
import { useState } from "react";
import { LogoutIconCircle } from "assets/icons";
import { useclearSession } from "hooks/api/useSettings";
import { useQueryClient } from "@tanstack/react-query";

function ActiveSessionCard({ data }) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const { mutate: clearSession, isLoading: updateLoading } = useclearSession({
    onSuccess: () => {
      setOpen(false);
      queryClient.invalidateQueries({ queryKey: ["SessionSettings"] });
    },
  });

  const handleClearSession = (id) => {
    setOpen(true);
    clearSession({ session_id: id });
  };

  return (
    <>
      <div className="active-session-card flex items-center justify-between gap-3">
        <div className="flex items-start gap-3 items-center">
          <span className="browser-icon">
            <img
              src={data?.icon === "chrome" ? chromeIcon : safariIcon}
              alt="browser-icon"
            />
          </span>
          <div className="details-container">
            <div className="flex items-center gap-1-5">
              <span className="font-title-xs">{data?.browser}</span>
              {data?.isCurrentSession && (
                <>
                  <Divider bgColor="#B5B1B5" circle height={6} width={6} />
                  <span className="font-title-xs">Current session</span>
                </>
              )}
            </div>
            <p className="browser-details">
              Last logged in {data?.lastLoggedIn}, {data?.location}
            </p>
          </div>
        </div>
        <Button
          className="forgot-password-btn"
          variant="link"
          onClick={() => setOpen(true)}
        >
          Log out
        </Button>
      </div>
      <ActionModal
        title="Log out of your account?"
        description="You’ll need to sign in again to continue."
        open={open}
        setOpen={setOpen}
        footer={{
          left: { label: "Cancel", action: () => setOpen(false) },
          right: { label: "Logout", action: () => handleClearSession(data.id) },
        }}
        icon={<LogoutIconCircle />}
      />
    </>
  );
}

export default ActiveSessionCard;
